import { createSelector } from 'reselect';

const fieldsSelector = state => state.field.fields;

export const getFields = createSelector(
    fieldsSelector,
    fields => fields,
);
